// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

//Services
import { Enums } from '../../shared/enums.js';
import { FeatureFlagService } from '../../shared/services/featureFlagService';

//Token
import { authToken } from '../../shared/authToken';

//Classes
import { FormNavigation } from "../../shared/classes/FormNavigation";

@Injectable()
export class NavFormsService {
    // PUBLIC MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _navigationForms = new BehaviorSubject([]);

    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _authToken = null;

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(featureFlagService: FeatureFlagService) {
        this.constructor.mapParams(this, arguments);
        this._authToken = authToken;
        this._setNavForms();
    }

    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //============================================
    // _setNavForms
    //============================================
    //Set Navigation form links based on role
    async _setNavForms() {
        
        //let assetTypeManagement = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.AssetTypeManagement);
        //let purposeManagement = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.PurposeManagementModule);
        //let stateCAPPAccess = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.StateCAPPAccess);
        //let stateResourceManagementAccess = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.StateResourceManagementAccess);
        let COMETPlanner = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.COMETPlanner);
        let advancedTagging = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.AdvancedTagging);
        let taggingManagement = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.TaggingManagement);
        let languageTranslation = await this.featureFlagService.getFeatureFlag(Enums.FeatureFlags.LanguageTranslation);
        let navArray = [];

        //Determine paths
        //let practicesViewPath = assetTypeManagement ? "/cpdes/practices/viewV2" : "/cpdes/practices/view";
        let practicesViewPath = "/cpdes/practices/viewV2";
        let assetTypeManagementPath = '/cpdes/practices/assetTypes';
        let position = 0;

        //Add the links
        switch (this._authToken.user.role) {

            // NHQNationalPracticeDataSteward
            //-------------------------------------
            case Enums.Roles.NHQNationalPracticeDataSteward.id:
                navArray.push(new FormNavigation('Asset Type Management', assetTypeManagementPath, ++position));
                navArray.push(new FormNavigation('Assets', practicesViewPath, ++position));
                navArray.push(new FormNavigation('Narrative Management', '/cpdes/practices/narratives', ++position));
                navArray.push(new FormNavigation('Resource Concern Mgt', '/cpdes/practices/resource', ++position));
                navArray.push(new FormNavigation('CAPP', '/cpdes/capp/main', ++position));
                navArray.push(new FormNavigation('CPD Transactions', '/cpdes/practices/cpdmanagement', ++position));
                navArray.push(new FormNavigation('Purpose Management', '/cpdes/practices/purposes', ++position));
                if (COMETPlanner) {
                    navArray.push(new FormNavigation('COMET Planner', '/cpdes/comet/view', ++position));
                }
                if (advancedTagging) {
                    navArray.push(new FormNavigation('Tagging', '/cpdes/tagging/narratives', ++position));
                }
                if (taggingManagement) {
                    navArray.push(new FormNavigation('Tagging Management', '/cpdes/tagging/taggingmanagement', ++position));
                }
                if (languageTranslation) {
                    navArray.push(new FormNavigation('Language Translation', '/cpdes/translation/assets', ++position));
                }
                break;

            // NHQNationalReportingDataSteward
            //-------------------------------------
            case Enums.Roles.NHQNationalReportingDataSteward.id:
                navArray = [
                    new FormNavigation('Assets', practicesViewPath, ++position)
                ];
                break;

            // StateDataSteward
            //-------------------------------------
            case Enums.Roles.StateDataSteward.id:
                navArray.push(new FormNavigation('CPD Transactions', '/cpdes/practices/cpdmanagement', ++position));
                navArray.push(new FormNavigation('Narrative Management', '/cpdes/practices/narratives', ++position));
                navArray.push(new FormNavigation('Assets', practicesViewPath, ++position));
                navArray.push(new FormNavigation('Select Assets', '/cpdes/practices/selectpractice', ++position));
                navArray.push(new FormNavigation('CAPP', '/cpdes/capp/main', ++position));
                navArray.push(new FormNavigation('Resource Concern Mgt', '/cpdes/practices/resource', ++position));
                if (COMETPlanner) {
                    navArray.push(new FormNavigation('COMET Planner', '/cpdes/comet/view', ++position));
                }
                break;

            // DataViewer
            //-------------------------------------
            case Enums.Roles.DataViewer.id:
                navArray = [
                    new FormNavigation('Narrative Management', '/cpdes/practices/narratives', ++position),
                    new FormNavigation('Assets', practicesViewPath, ++position)
                ];
                break;

            // TechSupport
            //-------------------------------------
            case Enums.Roles.TechSupport.id:
                navArray = [
                    new FormNavigation('Health Check', '/cpdes/healthcheck', ++position)
                ];
                break;

            // NationalDisciplineDataSteward
            //-------------------------------------
            case Enums.Roles.NationalDisciplineDataSteward.id:
                navArray = [
                    new FormNavigation('CPD Transactions', '/cpdes/practices/cpdmanagement', ++position),
                    new FormNavigation('Assets', practicesViewPath, ++position),
                    new FormNavigation('CAPP', '/cpdes/capp/main', ++position)
                ];

                navArray.push(new FormNavigation('Asset Type Management', assetTypeManagementPath, ++position));

                break;
        }
        console.log("[NavFormsService:setNavForms()] navLinks:", navArray);
        this._navigationForms.next(navArray);
    }
}